import { ReactNode } from 'react';

export const ModeTitleBanner = ({ title, children }: { title: ReactNode; children: ReactNode }) => {
  return (
    <div className="flex flex-col">
      <div
        style={{
          ['--image-url' as string]: `url('/assets/images/mode_dashboard_banner.png')`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
        className="flex justify-center items-center h-[257px] w-full min-h-[257px] bg-[image:var(--image-url)]"
      >
        <h1 className={`font-secondary z-10 relative text-5xl uppercase text-neutral-100 text-center font-bold`}>
          {title}
        </h1>
      </div>
      <div className="border border-neutral-950 border-x-0 mt-1 px-[15px] xl:px-0">
        <div className="mx-auto max-w-[1200px]">
          <div className="mt-[-50px]">{children}</div>
        </div>
      </div>
    </div>
  );
};
